import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const AttendanceActionBar = ({
  searchTerm,
  onSearchChange,
  filterDepartment,
  onDepartmentChange,
  filterStatus,
  onStatusChange,
  onExportCSV,
  departments = []
}) => {
  const departmentOptions = [
    { value: '', label: 'All Departments' },
    ...departments.map(dept => ({
      value: typeof dept === 'string' ? dept : dept.name || dept.value,
      label: typeof dept === 'string' ? dept : dept.label || dept.name
    }))
  ];

  const statusOptions = [
    { value: '', label: 'All Attendance Rates' },
    { value: 'high', label: 'High (>= 90%)' },
    { value: 'medium', label: 'Medium (75% - 89%)' },
    { value: 'low', label: 'Low (< 75%)' },
    { value: 'late_risks', label: 'Frequent Late (> 2 Days)' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6 shadow-sm">
      <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-4">
        {/* Search Input */}
        <div className="flex-1 max-w-md">
          <Input
            type="text"
            placeholder="Search employee by name, code, or role..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            icon="Search"
          />
        </div>

        {/* Filters and Actions */}
        <div className="flex flex-wrap items-center gap-3">
          <div className="w-44">
            <Select
              options={departmentOptions}
              value={filterDepartment}
              onChange={onDepartmentChange}
              placeholder="Department"
            />
          </div>

          <div className="w-48">
            <Select
              options={statusOptions}
              value={filterStatus}
              onChange={onStatusChange}
              placeholder="Filter Performance"
            />
          </div>

          <Button
            variant="outline"
            onClick={onExportCSV}
            iconName="Download"
            iconPosition="left"
          >
            Export Report
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AttendanceActionBar;
